export enum typeCreneauEnum {
	AC = 'AC',
	YFM = 'YFM'
}